import EditButton from '@orn/shared-web/components/Button/EditButton';
import SlideoutMenu from '@orn/shared-web/components/SlideoutMenu';
import { TypeIcon } from '@orn/shared-web/icons';

interface INameRowProps {
  name: string | null | undefined;
  /** When provided, renders a hover-revealed edit button left of the name that invokes this callback. */
  onEdit?: () => void;
}

const NameRow = ({ name, onEdit }: INameRowProps) => {
  if (!name) {
    return null;
  }

  return (
    <SlideoutMenu.Row className="group/name-row" icon={<TypeIcon className="size-4.5 shrink-0" />} title="Name">
      <div className="flex min-w-0 items-center gap-2">
        {onEdit && (
          <EditButton
            aria-label="Edit name"
            onClick={onEdit}
            className="shrink-0 opacity-0 transition-opacity focus-visible:opacity-100 group-hover/name-row:opacity-100"
          />
        )}
        <div className="text-primary text-md min-w-0 truncate font-medium">{name}</div>
      </div>
    </SlideoutMenu.Row>
  );
};

export default NameRow;
